import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

const LoadingMenuItem = () => (
  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '12px 16px', gap: '8px' }}>
    <CircularProgress size={16} thickness={4} sx={{ color: 'rgba(255, 255, 255, 0.7)' }} />
    <Typography variant="body2" sx={{ fontSize: '14px', color: 'rgba(255, 255, 255, 0.7)', fontStyle: 'italic' }}>
      Chargement en cours...
    </Typography>
  </Box>
);

export default LoadingMenuItem;
